import { Base } from 'src/models/base';
export class InstallerClientSMS extends Base {
  message: string;
  models: number | Base[];
}
